"use client";

import { c as _c } from "react/compiler-runtime";
import { useOrganizations } from "@/hooks/useOrganizations";
import { formatUsername } from "@/lib/utils";
import { useAuth, useProfile } from "@b3dotfun/sdk/global-account/react";
import { useMemo } from "react";
export function useInternalAlertActor() {
  const $ = _c(16);
  const {
    user,
    isAuthenticated,
    isAuthenticating
  } = useAuth();
  const authReady = !isAuthenticating;
  const shouldFetchProfile = authReady && isAuthenticated && !!user?.userId;
  const t0 = shouldFetchProfile ? user?.userId : undefined;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      address: undefined,
      name: undefined,
      b3GlobalId: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: profileData
  } = useProfile(t1);
  const {
    selectedOrgId,
    organizations
  } = useOrganizations();
  let t2;
  let t3;
  if ($[2] !== organizations || $[3] !== selectedOrgId) {
    t3 = organizations.find(org => org.id === selectedOrgId) ?? null;
    $[2] = organizations;
    $[3] = selectedOrgId;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  t2 = t3;
  const selectedOrg = t2;
  let t4;
  if ($[5] !== profileData?.name || $[6] !== user?.userId || $[7] !== user?.username) {
    t4 = () => formatUsername(profileData?.name) || formatUsername(user?.username) || user?.userId || undefined;
    $[5] = profileData?.name;
    $[6] = user?.userId;
    $[7] = user?.username;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  profileData?.name;
  user?.userId;
  user?.username;
  let t5;
  if ($[9] !== t4) {
    t5 = t4();
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const actorUsername = t5;
  const t6 = user?.userId;
  const t7 = selectedOrgId ?? undefined;
  const t8 = selectedOrg?.name;
  let t9;
  if ($[11] !== actorUsername || $[12] !== t6 || $[13] !== t7 || $[14] !== t8) {
    t9 = {
      actorUserId: t6,
      actorUsername,
      actorOrgId: t7,
      actorOrgName: t8
    };
    $[11] = actorUsername;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
}